// CmcUsageWidget/CmcUsageFetcher.js
// Singleton — does exactly 1 thing: raw I/O. No mapping, no business logic.
// TEMPORARY: mocked until CmcService.getUsageItems() (backend CmcAgent.GetUsages()) is wired.
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'CmcUsageFetcher';

// Raw API shape (CmcUsageItemDto), capitalized fields — mock, remove once real endpoint is wired.
const MOCK_USAGE_ITEMS = [
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 1, RK: 'Rate_limit_minute', Value: '50', Order: 0, Visible: 1, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 2, RK: 'Month_CreditsUsed', Value: '139', Order: 2, Visible: 1, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 3, RK: 'Month_CreditsLeft', Value: '14861', Order: 2, Visible: 1, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 9, RK: 'Minute_RequestUsed', Value: '2', Order: 10, Visible: 1, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 10, RK: 'Minute_RequestsLeft', Value: '48', Order: 10, Visible: 1, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 4, RK: 'Day_CreditsUsed', Value: '71', Order: 2, Visible: 1, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 5, RK: 'Day_CreditsLeft', Value: '0', Order: 2, Visible: 1, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 8, RK: 'Credit_limit_monthly_reset_timestamp', Value: '2026-08-01 00:00:00 +00:00', Order: 10, Visible: 0, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 7, RK: 'Credit_limit_monthly_reset', Value: 'In 10 days, 11 hours, 30 minutes', Order: 10, Visible: 0, Ems: 1784636998165 },
    { Date: '2026-07-21 12:29:58', local: '20260721 14:29:58', Id: 6, RK: 'Credit_limit_monthly', Value: '15000', Order: 10, Visible: 1, Ems: 1784636998165 },
];

class CmcUsageFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches the raw usage items (CmcUsageItemDto shape) — mocked for now.
     * @returns {Promise<object[]>}
     */
    fetch = async () => {
        try {
            return MOCK_USAGE_ITEMS;
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const cmcUsageFetcher = new CmcUsageFetcher();
export default cmcUsageFetcher;
